'use client'

import React from 'react'
import { Clock, AlignLeft, CalendarCheck, CheckCircle, ListChecks } from 'lucide-react'
import { RichText } from '../RichText'

interface RequirementItem {
  text: string
}

interface VisaOverviewProps {
  processingTime?: string
  duration?: string
  costRange?: string
  description?: any
  requirementsItems?: RequirementItem[]
}

export function VisaOverview({
  processingTime,
  duration,
  costRange: _costRange,
  description,
  requirementsItems = [],
}: VisaOverviewProps) {
  return (
    <section className="relative z-10">
      {/* Blue Banner with Stats */}
      <div className="bg-primary py-8 relative">
        <div className="max-w-380 mx-auto px-6 md:px-12">
          <div className="flex flex-wrap gap-6 sm:gap-12 md:gap-24 justify-start">
            {processingTime && (
              <div className="flex items-start gap-4">
                <div className="shrink-0 w-12 h-12 flex items-center justify-center">
                  <Clock
                    className="w-8 h-8 text-brand-gold"
                    strokeWidth={1.75}
                    strokeLinecap="butt"
                  />
                </div>
                <div>
                  <h3 className="text-2xl font-medium text-white">{processingTime}</h3>
                  <p className="text-base text-white/70">Processing Time</p>
                </div>
              </div>
            )}

            {duration && (
              <div className="flex items-start gap-4">
                <div className="shrink-0 w-12 h-12 flex items-center justify-center">
                  <CalendarCheck
                    className="w-8 h-8 text-brand-gold"
                    strokeWidth={1.75}
                    strokeLinecap="butt"
                  />
                </div>
                <div>
                  <h3 className="text-2xl font-medium text-white">{duration}</h3>
                  <p className="text-base text-white/70">Duration</p>
                </div>
              </div>
            )}

            {/* {costRange && (
              <div className="flex items-start gap-4">
                <div className="shrink-0 w-12 h-12 flex items-center justify-center">
                  <PiggyBank
                    className="w-8 h-8 text-brand-gold"
                    strokeWidth={1.75}
                    strokeLinecap="butt"
                  />
                </div>
                <div>
                  <h3 className="text-2xl font-medium text-white">{costRange}</h3>
                  <p className="text-base text-white/70">Cost Range</p>
                </div>
              </div>
            )} */}
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="max-w-380 mx-auto px-6 md:px-12 py-16 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16">
          {/* Left side - Overview Description */}
          <div className="max-w-[70ch]">
            <h2 className="text-2xl font-semibold text-brand-gold mb-2">
              <AlignLeft
                className="inline-block mr-3 text-brand-gold mb-[3px] -ml-0.5"
                strokeWidth={3}
              />
              Overview
            </h2>
            {description && (
              <div className="border-l-[2px] border-brand-gold/90 p-6 md:p-8 py-2!">
                <RichText
                  data={description}
                  className="[&>p:not(:last-child)]:mb-4 text-base md:text-lg text-gray-900 leading-relaxed"
                />
              </div>
            )}
          </div>

          {/* Right side - Key Requirements */}
          {requirementsItems.length > 0 && (
            <div>
              <h3 className="text-2xl font-semibold text-brand-gold mb-4">
                <ListChecks
                  className="inline-block mr-3 text-brand-gold mb-[3px] -ml-0.5"
                  strokeWidth={3}
                />
                Key Requirements
              </h3>
              <ul className="space-y-2">
                {requirementsItems.map((item, index) => (
                  <li key={index} className="flex items-center gap-3">
                    <CheckCircle
                      className="w-4 h-4 text-brand-gold shrink-0 mb-px"
                      strokeWidth={3}
                    />
                    <span className="text-base md:text-lg text-gray-900 leading-relaxed">
                      {item.text}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}
